import { render, staticRenderFns } from "./StartConfirm.vue?vue&type=template&id=2b4241c7&scoped=true"
import script from "./StartConfirm.vue?vue&type=script&lang=js"
export * from "./StartConfirm.vue?vue&type=script&lang=js"
import style0 from "./StartConfirm.vue?vue&type=style&index=0&id=2b4241c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4241c7",
  null
  
)

export default component.exports